import { gql, useLazyQuery } from "@apollo/client";
import {
  GetNotificationSettingQuery,
  GetNotificationSettingQueryVariables,
} from "../generated/graphql";

const GET_NOTIFICATION_SETTING_QUERY = gql`
  query getNotificationSetting {
    getNotificationSetting {
      ok
      err
      setting {
        id
        adminNotifyPhone
        customerMessageTemplate
        orderCompleteMessageTemplate
        droneFlightMessageTemplate
      }
    }
  }
`;

export const useGetNotificationSetting = (
  onCompleted?: (data: GetNotificationSettingQuery) => void
) => {
  return useLazyQuery<
    GetNotificationSettingQuery,
    GetNotificationSettingQueryVariables
  >(GET_NOTIFICATION_SETTING_QUERY, {
    onCompleted,
    fetchPolicy: "network-only",
  });
};
